<template>
  <div v-if="currentUser && currentUser.isBanned">
    <div class="anz-bg-black-3 anz-p-xl anz-my-xl anz-align-center">
      <h6 class="anz-fs-m anz-mb-m anz-color-primary">
        {{ $translate('post.texts.bannedHeader') }}
      </h6>
      {{ $translate('post.texts.banned') }}
    </div>
  </div>
</template>

<script>
import useCurrentUser from '@/composables/user/user'

export default {
  name: 'PostRespondBanned',
  setup() {
    const { currentUser } = useCurrentUser()

    return {
      currentUser,
    }
  },
}
</script>
